(() => {
  const swiperSelector = '.swiper-upsell[js-cart-upsell-slider]';

  const initSwiper = (el) => {
    if (!window.Swiper || el.classList.contains('swiper-initialized')) return;

    const container = el.closest('[data-upsell-slider-root]') || document;
    const nextBtn = container.querySelector('.swiper-button-next');
    const prevBtn = container.querySelector('.swiper-button-prev');

    new Swiper(el, {
      slidesPerView: 2.3,
      spaceBetween: 16,
      mousewheel: { forceToAxis: true },
      direction: 'horizontal',
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      observer: true,
      observeParents: true,          
      breakpoints: {
        0: {
          slidesPerView: 2.1, 
          spaceBetween: 16
        },
        750: {
          slidesPerView: 2.388,
          spaceBetween: 16
        }
      }
    });
  };

  const scan = () => {
    document.querySelectorAll(swiperSelector).forEach(initSwiper);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  const observer = new MutationObserver(() => {
    scan();
  });

  observer.observe(document.body, { childList: true, subtree: true }); 

  // Re-init after cart updates (e.g., drawer re-render)
  document.addEventListener('cart:update', () => {
    // Delay to allow DOM replacement to finish
    setTimeout(scan, 0);
  });
})();
